/* global revenueContractsIndexUrl, supplierContractTermsIndexUrl, supplierContractTermStoreUrl, supplierContractTermUpdateUrl, cancelRevenueCommitmentUrl,
supplierContractTermDeleteUrl, downloadSupplierContractsTermAttachmentUrl, deleteSupplierContractsTermAttachmentUrl, revenueContractDeleteUrl eventStartDate eventEndDate exportRevenueContractsToFile */

import React, { useCallback, useState } from 'react';

import RevenueContractsTableIndex from './RevenueContractsTableIndex';

export default function RevenueContractsIndex({ updateSignedContractUrl, revDepartmentsOptions, ownersOptions }) {
    const [refreshKey, setRefreshKey] = useState(0);

    // Function to trigger a refresh
    const triggerRerender = useCallback(() => {
        setRefreshKey((prevKey) => prevKey + 1);
    }, []);

    return (
        <div className="tw-flex tw-flex-col tw-gap-y-4">
            <RevenueContractsTableIndex
                key={`uncancelled-${refreshKey}`} // Ensure rerender when refreshKey changes
                fetchUrl={revenueContractsIndexUrl}
                forCancel={false}
                supplierContractTermsIndexUrl={supplierContractTermsIndexUrl}
                supplierContractTermStoreUrl={supplierContractTermStoreUrl}
                supplierContractTermUpdateUrl={supplierContractTermUpdateUrl}
                supplierContractTermDeleteUrl={supplierContractTermDeleteUrl}
                downloadSupplierContractsTermAttachmentUrl={downloadSupplierContractsTermAttachmentUrl}
                deleteSupplierContractsTermAttachmentUrl={deleteSupplierContractsTermAttachmentUrl}
                revenueContractDeleteUrl={revenueContractDeleteUrl}
                cancelRevenueCommitmentUrl={cancelRevenueCommitmentUrl}
                updateSignedContractUrl={updateSignedContractUrl}
                triggerRerender={triggerRerender}
                eventStartDate={eventStartDate}
                eventEndDate={eventEndDate}
                revDepartmentsOptions={revDepartmentsOptions}
                ownersOptions={ownersOptions}
                exportToFile={exportRevenueContractsToFile}
            />
            <RevenueContractsTableIndex
                key={`closed-${refreshKey}`} // Ensure rerender when refreshKey changes
                fetchUrl={revenueContractsIndexUrl}
                forCancel={false}
                forClosed={true}
                supplierContractTermsIndexUrl={supplierContractTermsIndexUrl}
                supplierContractTermStoreUrl={supplierContractTermStoreUrl}
                supplierContractTermUpdateUrl={supplierContractTermUpdateUrl}
                supplierContractTermDeleteUrl={supplierContractTermDeleteUrl}
                downloadSupplierContractsTermAttachmentUrl={downloadSupplierContractsTermAttachmentUrl}
                deleteSupplierContractsTermAttachmentUrl={deleteSupplierContractsTermAttachmentUrl}
                revenueContractDeleteUrl={revenueContractDeleteUrl}
                cancelRevenueCommitmentUrl={cancelRevenueCommitmentUrl}
                updateSignedContractUrl={updateSignedContractUrl}
                triggerRerender={triggerRerender}
                eventStartDate={eventStartDate}
                eventEndDate={eventEndDate}
                revDepartmentsOptions={revDepartmentsOptions}
                ownersOptions={ownersOptions}
                exportToFile={exportRevenueContractsToFile}
            />
        </div>
    );
}
